export class EMailData
{
  to:string;
  subject:string;
  message:string;
  reply:string;  
}
